import { apiFetch } from './api.js';
import { isTaskLocal, runLocalTaskNow } from './localTaskRun.js';

export async function dispatchScheduledTask(task) {
  if (!task) return { ok: false, error: 'Tarefa não encontrada; atualize a agenda' };
  const catalog = await apiFetch('/api/adapters?kind=text');
  if (!catalog.ok) return catalog;
  const adapters = Object.fromEntries((catalog.data?.adapters || []).map((adapter) => [adapter.id, adapter]));
  if (!isTaskLocal(task, adapters)) return apiFetch(`/api/code-ide/schedule/${task.id}/run`, { method: 'POST' });
  try { return { ok: true, data: await runLocalTaskNow(task, adapters) }; }
  catch (error) { return { ok: false, error: error.message }; }
}
